import { z } from 'zod';

/**
 * One manually-curated CAD part anchor shared by the generic CAD utilities.
 * Keeping this beside cadPartLabels avoids making utils depend on a feature.
 *
 * MIRROR — api/routes/drbfm.py:123-128 (PredefinedPartLabel):
 *   position: List[float] = Field(min_length=3, max_length=3) -> the tuple;
 *   each value must be a finite number.
 * `label` and `category` are bare `str` server-side; requiring non-blank text
 * is the existing frontend rule because both fields are required in the UI.
 */
export const partLabelSchema = z.object({
  label: z.string().trim().min(1),
  position: z.tuple([
    z.number().finite(),
    z.number().finite(),
    z.number().finite(),
  ]),
  category: z.string().trim().min(1),
  note: z
    .unknown()
    .optional()
    .transform((value) => (typeof value === 'string' ? value.trim() || null : null)),
});
